import BillStatusListingModel from './bill_status_listing_model';
export default Backbone.Collection.extend({
  model: BillStatusListingModel
});